const MapIcon = props => (
	<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g id="map">
			<path
				id="Vector"
				d="M10.25 1.5L10.17 1.515L7.5 2.55L4.5 1.5L1.68 2.45C1.575 2.485 1.5 2.575 1.5 2.69V10.25C1.5 10.39 1.61 10.5 1.75 10.5L1.83 10.485L4.5 9.45L7.5 10.5L10.32 9.55C10.425 9.515 10.5 9.425 10.5 9.31V1.75C10.5 1.61 10.39 1.5 10.25 1.5ZM5 2.735L7 3.435V9.265L5 8.565V2.735ZM2.5 3.23L4 2.725V8.575L2.5 9.155V3.23ZM9.5 8.77L8 9.275V3.43L9.5 2.85V8.77Z"
				fill="black"
			/>
		</g>
	</svg>
);

export default MapIcon;
